import useRelatedQuestions from '../../hooks/useRelatedQuestions';
import { type RichEndingsProps, Wrapper } from '../RichEndings';
import RelatedQuestions from './RelatedQuestions';

import type { MiniInterviewType } from 'src/packages/polaris/types';

// Interviews that support related questions. Txoc is excluded to avoid reducing conversions at completion
const relatedQuestionsSupportedTypes: MiniInterviewType[] = [
  'symptoms',
  'emergency',
  'dxoc',
  'treatmentGuidance',
];

const RelatedQuestionsWrapper = (props: RichEndingsProps) => {
  const { interviewType } = props;

  const { data, isLoading: questionsDataLoading } = useRelatedQuestions(props);

  const questionsData = data?.related_questions;

  const isSupportedInterviewType = relatedQuestionsSupportedTypes.includes(interviewType);

  return isSupportedInterviewType && (!!questionsData?.length || questionsDataLoading) ? (
    <Wrapper component="RelatedQuestions">
      <RelatedQuestions isLoading={questionsDataLoading} questions={questionsData || []} />
    </Wrapper>
  ) : null;
};

export default RelatedQuestionsWrapper;
